import axios from 'axios';

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  'https://bb-backend-server.onrender.com';

if (!BACKEND_URL && process.env.NODE_ENV !== 'test') {
  // In production, prefer setting REACT_APP_BACKEND_URL explicitly.
  console.warn('REACT_APP_BACKEND_URL is not set. Falling back to same-origin /api.');
}

const api = axios.create({
  baseURL: BACKEND_URL ? `${BACKEND_URL}/api` : '/api',
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use((config) => {
  const restId = localStorage.getItem('biten_restaurant_id');
  if (restId) {
    config.headers['x-restaurant-id'] = restId;
  }
  return config;
});

// Tokens now expire server-side; on 401 clear the stale session so the user
// is sent back through login instead of seeing every request fail.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      if (window.location.pathname.startsWith('/manage')) {
        localStorage.removeItem('biten_admin');
        delete api.defaults.headers.common['Authorization'];
        if (!window.location.pathname.startsWith('/manage/login')) {
          window.location.assign('/manage/login');
        }
      } else {
        localStorage.removeItem('biten_auth');
        delete api.defaults.headers.common['Authorization'];
      }
    }
    return Promise.reject(error);
  }
);

export default api;
export { BACKEND_URL };
